// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Nkfb9","overflowing":"ReadFullNote_overflowing__1gReX"};